import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import getFullUserName from 'utils/getFullUserName';
import Avatar from 'components/Avatar';
import Flag from 'components/Flag';
import Heading from 'components/Heading';
import Icon from 'components/Icon';
import InlineList from 'components/InlineList';
import IconDisc from 'components/IconDisc';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import EasyTooltip from 'components/EasyTooltip';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AvatarWrapper = styled(TextLink).withConfig({
  displayName: "UserHeader__AvatarWrapper",
  componentId: "sc-uln18w-0"
})(["display:block;position:relative;"]);
var HoverIcon = styled(IconDisc).withConfig({
  displayName: "UserHeader__HoverIcon",
  componentId: "sc-uln18w-1"
})(["position:absolute;top:0;left:0;opacity:0;transform:perspective(400px) rotate3d(1,0,0,90deg) scale(0.1);will-change:opacity,transform;transition:all ease 200ms;", ":hover &{opacity:0.9;transform:none;}"], AvatarWrapper);
var EditableAvatar = function EditableAvatar(_ref) {
  var pictureUrl = _ref.pictureUrl;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(EasyTooltip, {
    content: t('actions_change_avatar'),
    children: /*#__PURE__*/_jsxs(AvatarWrapper, {
      as: Link,
      to: "/settings",
      "aria-hidden": "true",
      children: [/*#__PURE__*/_jsx(Avatar, {
        shady: true,
        pictureUrl: pictureUrl,
        size: "big"
      }), /*#__PURE__*/_jsx(HoverIcon, {
        inverted: true,
        name: "edit",
        size: "big"
      })]
    })
  });
};
var UserHeader = function UserHeader(_ref2) {
  var profile = _ref2.profile;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var fullName = getFullUserName(profile);
  return /*#__PURE__*/_jsxs(Flag, {
    align: "center",
    spacing: "m",
    token: /*#__PURE__*/_jsx(EditableAvatar, {
      pictureUrl: profile.pictureUrl || ''
    }),
    stackBelow: "xs",
    id: "user_profile_heading",
    children: [/*#__PURE__*/_jsx(Heading, {
      as: "p" // Rendering as a "p" as the page has a visually hidden heading
      ,
      size: "large",
      children: fullName || profile.email
    }), /*#__PURE__*/_jsx(Text, {
      dimmed: true,
      as: "p",
      id: "my_learning_heading",
      overflow: "wrap",
      children: /*#__PURE__*/_jsxs(InlineList, {
        as: "span",
        itemAs: "span",
        splitBy: "dot",
        children: [fullName ? profile.email : t('profile_name_empty_cta'), /*#__PURE__*/_jsxs(TextLink, {
          as: Link,
          to: "/settings",
          id: "profile_user_name",
          children: [t(fullName ? 'navbar_user_settings' : 'actions_set_name_or_language'), /*#__PURE__*/_jsx(Icon, {
            vAlign: true,
            name: "edit",
            ml: "xxs"
          })]
        })]
      })
    })]
  });
};
export default UserHeader;